import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { UIComponentsModule } from "../ui-components.module";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { OrganisationBilling, getBillingStatusDescription, BILLING_STATUS } from "../../common/organisation";
import { DatePipe, DecimalPipe } from "@angular/common";
import { MaterialModule } from "../../material/material.module";

@Component({
    selector: 'app-billing-records-table',
    templateUrl: './billing-records-table.html',
    styleUrls: ['./billing-records-table.css'],
    standalone: true,
    imports: [MaterialModule, UIComponentsModule, DatePipe, DecimalPipe],
    providers: [DatePipe]
})
export class BillingRecordsTableComponent implements OnInit, OnChanges {
    @Input() billingRecords:OrganisationBilling[]
    
    billingData:MatTableDataSource<OrganisationBilling> = new MatTableDataSource<OrganisationBilling>()
    @ViewChild(MatSort) sort: MatSort

    columns = ['organisationName', 'runId', 'createdDate', 'status', 'paidDate', 'currencyCode', 'nodes', 'projects', 'users', 'amount', 'error'];
    headings = ['Organisation', 'ID', 'Created', 'Billing state', 'Payment date', 'Currency', 'Nodes', 'Projects', 'Users', 'Billing amount', 'Error'];

    constructor() {}

    ngOnInit(): void {
        this.populateData()
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['billingRecords'])
            this.populateData()
    }

    populateData() {
        this.billingData.data = this.billingRecords.sort((a,b) => a.createdDate > b.createdDate?-1:1)
        this.billingData.sort = this.sort;
    }

    getBillingStatus(status:BILLING_STATUS) {
        return getBillingStatusDescription(status)
    }

    sortChange(event) {
        if (event.direction!=='') {
            this.billingData.data = this.billingRecords.sort((a,b) => {
                let aValue:any,bValue:any
                if (event.active === 'nodes' || event.active === 'organisations' || event.active === 'projects' || event.active === 'users') {
                    aValue = a[event.active].number
                    bValue = b[event.active].number
                }else {
                    aValue = a[event.active]
                    bValue = b[event.active]
                }
                if (aValue > bValue)
                    return (event.direction === "asc")?1:-1
                else return (event.direction === "asc")?-1:1
            })
        }
    }
}